import axios from 'axios';

/** Match the backend's explicit conflict, never infer recovery from HTTP 409 alone. */
export function isVerificationSelectionChanged(error: unknown): boolean {
  return axios.isAxiosError(error)
    && error.response?.status === 409
    && error.response.data?.code === 'verification_selection_changed';
}
